import { render, staticRenderFns } from "./Promocodes.vue?vue&type=template&id=21d5281f&scoped=true"
import script from "./Promocodes.vue?vue&type=script&lang=js"
export * from "./Promocodes.vue?vue&type=script&lang=js"
import style0 from "./Promocodes.vue?vue&type=style&index=0&id=21d5281f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5281f",
  null
  
)

export default component.exports